import { useEffect, useState } from 'react';

/** Wall-clock `now` that re-samples every second so countdowns tick; `setNow` re-anchors it after server updates. */
export function useCountdownNow(): [number, (at: number) => void] {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  return [now, setNow];
}
